/**
 * Text as the editor saved it, with its non-breaking spaces made ordinary.
 *
 * Quill saves some text - pasted text above all - with a non-breaking space
 * between every two words. To the browser that is one long word, which it
 * can only wrap in the middle of words: "button c|opyTesting". An ordinary
 * space lets it wrap between them (#173).
 */
export function breakableSpaces(text: string | null | undefined): string {
    return (text ?? "").replace(/&nbsp;| /g, " ");
}

/**
 * The same, for what is saved: a lone non-breaking space between two words
 * becomes an ordinary one, so text is stored as it is meant and not only shown
 * so. A run of them stays as it is - that is the editor keeping spaces typed
 * one after another, which an ordinary run of spaces would lose.
 */
export function savableSpaces(html: string | null | undefined): string {
    return (html ?? "").replace(/(?<!&nbsp;| |\s)(?:&nbsp;| )(?!&nbsp;| |\s)/g, " ");
}
